module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(476);
	module.exports = __webpack_require__(476);


/***/ },

/***/ 3:
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },

/***/ 476:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(477), __webpack_require__(478) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {
	    // Imports ================================================================
	    var noop = $.noop,

	        kendo = window.kendo,
	        Class = kendo.Class,
	        util = kendo.util,

	        animationFrame = kendo.animationFrame,
	        deepExtend = kendo.deepExtend;

	    // Base element animation ================================================
	    var Animation = Class.extend({
	        init: function(element, options) {
	            var anim = this;

	            anim.options = deepExtend({}, anim.options, options);
	            anim.element = element;
	        },

	        options: {
	            duration: 500,
	            easing: "swing"
	        },

	        setup: noop,
	        step: noop,

	        play: function() {
	            var anim = this,
	                options = anim.options,
	                easing = $.easing[options.easing],
	                duration = options.duration,
	                delay = options.delay || 0,
	                start = util.now() + delay,
	                finish = start + duration;

	            if (duration === 0) {
	                anim.step(1);
	                anim.abort();
	            } else {
	                setTimeout(function() {
	                    var loop = function() {
	                        if (anim._stopped) {
	                            return;
	                        }

	                        var wallTime = util.now();

	                        var time = util.limitValue(wallTime - start, 0, duration);
	                        var pos = time / duration;
	                        var easingPos = easing(pos, time, 0, 1, duration);

	                        anim.step(easingPos);

	                        if (wallTime < finish) {
	                            animationFrame(loop);
	                        } else {
	                            anim.abort();
	                        }
	                    };

	                    loop();
	                }, delay);
	            }
	        },

	        abort: function() {
	            this._stopped = true;
	        },

	        destroy: function() {
	            this.abort();
	        }
	    });

	    // Animation factory =====================================================
	    var AnimationFactory = function() {
	        this._items = [];
	    };

	    AnimationFactory.prototype = {
	        register: function(name, type) {
	            this._items.push({
	                name: name,
	                type: type
	            });
	        },

	        create: function(element, options) {
	            var items = this._items;
	            var match;

	            if (options && options.type) {
	                var type = options.type.toLowerCase();
	                for (var i = 0; i < items.length; i++) {
	                    if (items[i].name.toLowerCase() === type) {
	                        match = items[i];
	                        break;
	                    }
	                }
	            }

	            if (match) {
	                return new match.type(element, options);
	            }
	        }
	    };

	    AnimationFactory.current = new AnimationFactory();

	    Animation.create = function(type, element, options) {
	        return AnimationFactory.current.create(type, element, options);
	    };

	    // Exports ================================================================
	    deepExtend(kendo.drawing, {
	        Animation: Animation,
	        AnimationFactory: AnimationFactory
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ },

/***/ 477:
/***/ function(module, exports) {

	module.exports = require("./geometry");

/***/ },

/***/ 478:
/***/ function(module, exports) {

	module.exports = require("./core");

/***/ }

/******/ });